import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const ToastMessages = ({open, setOpen, toastMessage, type}) => {

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }

        setOpen(false);
    };
    
    return(
        <Snackbar 
            open={open} 
            autoHideDuration={3000} 
            onClose={handleClose} 
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Alert
                onClose={handleClose}
                severity={type}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {toastMessage}
            </Alert>
        </Snackbar>
    );
};

export default ToastMessages;